import type { FaireProductEntity } from "../../entity_types/product";

export const p_2d12vzoz: FaireProductEntity = {
  token: "p_2d12vzoz",
  type: "product",
  name: "Teakwood & Tobacco - 7.2 oz Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/2056bb844aea17dc429ae2dd4e93e1ab9495c1a686339251052d0e8cb99ab88a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0208a71b23aec151da1626fc4c5b434a1e8f114e6c485aa004427fbe46ee46d0.jpeg",
    "https://cdn.faire.com/fastly/58f12fa9bbb6df843dadc348124957075e5d3c319c4e28e27fcaa8aca960bacd.jpeg",
    "https://cdn.faire.com/fastly/bf9096483b520927323701a02fc196e00465685f2590ee43c17543681e36a745.png",
    "https://cdn.faire.com/fastly/13db08b780cc750e852f02c52e31fd039a2b76c0bcb7e9650aba1e57d090201c.jpeg",
    "https://cdn.faire.com/fastly/b140379e7c65365648b4e37b5c13608e3eaf8e67afafd384345bd924a295e1dd.jpeg",
    "https://cdn.faire.com/fastly/c92432806d41e3d6f3c618531fde5312106f715a6cf03bbac99e6996e1de4217.jpeg",
  ],
  priceDollars: 11,
  description:
    "The one that started it all. Some call it the boyfriend scent, we call it the O.G. Leather, teak, and orange.\n\nOur best-selling 7.2 oz Standard Size. This is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\nHand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid. Our candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours.",
  tags: [],
  msrpDollars: 23.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:13.628Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
